import { useCallback } from "react";
import { EXTERNAL_PREVIEW, ROLES } from "@consts";

const useExternalPreviewRedirect = (user, location) => useCallback(() => {
  if (
    user?.roles?.at(0)?.key === ROLES.EXTERNAL &&
        user?.roles.length === 1 &&
        location.pathname !== `/${EXTERNAL_PREVIEW}`
  ) {
    const previewLink = JSON.parse(user.metadata)?.previewLink;
    if (previewLink) {
      window.location.href = previewLink;
      return true;
    }
  }
  return false;
}, [user, location]);

export default useExternalPreviewRedirect;
